import { defineMessages } from "react-intl";

const messages = defineMessages({
    rhythm: {
        id: "meta.rhythm",
    },
    tempoFeel: {
        id: "meta.tempoFeel",
    },
    timeSignature: {
        id: "meta.timeSignature",
    },
    isUpbeat: {
        id: "meta.isUpbeat",
    },
    rhythmPatterns: {
        id: "meta.rhythmPatterns",
    },
    rhythmPatternsOnly: {
        id: "meta.rhythmPatternsOnly",
    },
    isRepeat: {
        id: "meta.isRepeat",
    },
    alternating: {
        id: "meta.alternating",
    },
});

export default messages;
